export default class GenesysAudioService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId
  }

  async getWebRTCToken(params, callback) {
    const url = `${this.host}/accounts/${this.accountId}/genesys-audio-webrtc-token`
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(callback)
  }
}
